export const TITLE = 'Artist Profile';
export const GENRE_TEXT = 'Preferred Genres';
export const GENRE_SUB_TEXT = 'Your three preferred genres';
export const PROFILE_SAVED = 'Your profile has been saved';
